import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';
import { ISelectedJob } from '../../../../../src/js/lib/types/AppState/LandingPage.interface';
import { IGetMatchesParams, ISubmitMatchesParams } from './PropagateMatchesTypes';

export const getMatches = async ({
  activeSurveyYear,
  masterAccountID,
  sourceJobs,
}: IGetMatchesParams) => {
 const matchesURL = `/cms/api/accounts/${masterAccountID}/propagate-matches/getMatches`;
 try {
    const updatedSourceJobs = sourceJobs.map(job => {
      if (!job.sourceMatches) return job;

      return {...job, sourceMatches: job.sourceMatches.map(targetMatch => {
        return {
          sourceMatchId: targetMatch.sourceMatchId,
          surveyCode: targetMatch.surveyCode,
          surveyJobCode: targetMatch.surveyJobCode,
          currency: targetMatch.currency,
          jobScope: targetMatch.jobScope,
          jobTitle: targetMatch.jobTitle,
          cutId: targetMatch.cutId,
          surveyPublisher: targetMatch.surveyPublisher,
          filter: targetMatch.filter || "",
          sort: targetMatch.sort || { property: 'target_currency', direction: 'ASC' },
          limit: targetMatch.limit || 15,
          offset: targetMatch.offset || 0
        }
      })}
    })

    const options = {
      sourceJobs: updatedSourceJobs,
      activeSurveyYear
    };
    const results = await apiClient.post(matchesURL, options);

    return results.data.data.orgJobs;
  } catch (error) {
    console.error(`Error fetching propagate matches:`, error);
    return Promise.resolve({ data: [], terms: [] });
  }
};

export const getOrgJobsData = async (jobs: ISelectedJob[]) => {
  const orgJobsURL = `/api/market-pricing/jobs/getJobs`;
  try {
    const ids = jobs.map((job: ISelectedJob) => job.jobID);
    const results = await apiClient.apiGet(orgJobsURL, {
      params: {
        orgJobIds: ids,
      },
    });

    return results.data.orgJobs;
  } catch (error) {
    console.error(`Error fetching org job data:`, error);
    addAlert('Error fetching org job data.', 'danger');
    return Promise.resolve({ data: [], terms: [] });
  }
};

export const submitMatches = async ({
  masterAccountID,
  propagateMatches,
  surveyYear,
}: ISubmitMatchesParams) => {
  const matchesURL = `/cms/api/accounts/${masterAccountID}/propagate-matches/submitMatches`;
  try {
    const options = {
      propagateMatches,
      surveyYear,
    };
    const results = await apiClient.post(matchesURL, options);
    const successMessage = `Successfully added ${results.data.data.successfulMatches.length} match(es)`;
    addAlert(successMessage, 'success');
    return results.data;
  } catch (error) {
    console.error(`Error submitting propagate matches:`, error);
    return Promise.resolve({ data: [], terms: [] });
  }
};
